import { UIState } from 'src/state/uiState'

import tailwindConfig from './tailwind.config'

import { ThemeConfig } from 'antd'
import resolveConfig from 'tailwindcss/resolveConfig'
import { RecursiveKeyValuePair } from 'tailwindcss/types/config'

const fullTailwindConfig = resolveConfig(tailwindConfig)

export const resolveThemeConfig = (ui: UIState): ThemeConfig => {
    return {
        token: {
            colorPrimary: ui.colors.primary,
            fontSize: 13,

            colorBorder: fullTailwindConfig.theme.borderColor['DEFAULT'],

            // Align breakpoint of Ant Design with Tailwind
            screenSM: parseInt(fullTailwindConfig.theme.screens.sm.replace('px', '')),
            screenMD: parseInt(fullTailwindConfig.theme.screens.md.replace('px', '')),
            screenLG: parseInt(fullTailwindConfig.theme.screens.lg.replace('px', '')),
            screenXL: parseInt(fullTailwindConfig.theme.screens.xl.replace('px', '')),
            screenXXLMin: parseInt(fullTailwindConfig.theme.screens['2xl'].replace('px', '')),
            screenXXL: parseInt(fullTailwindConfig.theme.screens['2xl'].replace('px', '')),
            screenXLMax: parseInt(fullTailwindConfig.theme.screens['2xl'].replace('px', '')),
        },
        components: {
            Collapse: {
                headerBg: (fullTailwindConfig.theme.backgroundColor.slate as unknown as RecursiveKeyValuePair)[
                    '200'
                ].toString(),
                contentBg: '#ffffff !important',
            },
            List: {
                headerBg: fullTailwindConfig.theme.colors['allgrey'],
            },
            Popconfirm: {
                zIndexPopup: 9999,
            },
            Message: {
                zIndexPopup: 9999,
            },
            Notification: {
                zIndexPopup: 9999,
            },

            Table: {
                cellPaddingBlock: 4, // is way bigger by default but requested by product owner
            },
            Descriptions: {
                titleMarginBottom: 8,
            },
        },
    }
}
